var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bounce-loader',{attrs:{"loading":_vm.loading,"color":"#68d391","size":100}}),(!_vm.loading)?_c('px-assets-table',{attrs:{"assets":_vm.assets}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }